import React from 'react';
import { useIntl } from 'react-intl';
import { graphql, useStaticQuery } from 'gatsby';

import Img, { FluidObject } from 'gatsby-image';

import type { MessageKey } from 'modules/intl';

interface ImageProps {
    alt: MessageKey;
}

export const Image = ({ alt }: ImageProps) => {
    const { formatMessage } = useIntl();
    const imageAlt = formatMessage({ id: alt });

    const {
        allFile: { nodes },
    } = useStaticQuery<Queries.Query>(graphql`
        query {
            allFile(filter: { relativeDirectory: { eq: "inquiry/book-call" }, base: { eq: "jan_misar.png" } }) {
                nodes {
                    base
                    childImageSharp {
                        fluid(quality: 90) {
                            ...GatsbyImageSharpFluid_withWebp_tracedSVG
                        }
                    }
                }
            }
        }
    `);

    const imageFile = nodes[0];

    if (!imageFile?.childImageSharp?.fluid) return null;

    return (
        <Img
            alt={imageAlt}
            imgStyle={{ objectFit: 'contain', objectPosition: 'bottom' }}
            style={{ height: '100%' }}
            fluid={imageFile.childImageSharp.fluid as FluidObject}
        />
    );
};
